<script>
  import * as restfulService from '../../../../services/restfulService'
  import {mapGetters, mapActions} from 'vuex'
  import bus from '@utils/bus'
  import {cloneDeep} from 'lodash'

  export default {
    data () {
      return {
        data: {
          sms: true,
          notificacoes_notas: true,
          notificacoes_provas: true,
          notificacoes_agenda: true,
          notificacoes_boletos: true
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser'])
    },
    mounted () {
      this.buscarDados()
    },
    methods: {
      ...mapActions(['showNotification']),
      buscarDados () {
        restfulService.get('usuario', null, this.currentUser.id)
          .then((response) => {
            this.data = response
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      salvarDados () {
        bus.$emit('show-loader')
        let data = cloneDeep(this.data)
        restfulService.put('usuario', 'notificacoes', null, data)
          .then(() => {
            this.showNotification({
              message: 'Suas configurações de notificações foram salvas'
            })
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="meu-perfil notificacoes">
        <h2 class="meu-perfil-titulo">
            <i class="fas fa-bell"></i>
            <span class="pl-2">Notificações</span>
        </h2>
        <div class="perfil-items">
            <div class="perfil-item">
                <div class="perfil-label">SMS</div>
                <div class="perfil-text"><v-switch v-model="data.sms" color="orange darken-3"></v-switch></div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Notas</div>
                <div class="perfil-text"><v-switch v-model="data.notificacoes_notas" color="orange darken-3"></v-switch></div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Provas</div>
                <div class="perfil-text"><v-switch v-model="data.notificacoes_provas" color="orange darken-3"></v-switch></div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Agenda</div>
                <div class="perfil-text"><v-switch v-model="data.notificacoes_agenda" color="orange darken-3"></v-switch></div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Boletos</div>
                <div class="perfil-text"><v-switch v-model="data.notificacoes_boletos" color="orange darken-3"></v-switch></div>
            </div>
        </div>
        <v-btn color="success" @click="salvarDados()">
            <i class="fas fa-check"></i>
            <span class="pl-2">Salvar Dados</span>
        </v-btn>
    </div>
</template>

<style lang="scss">
    .meu-perfil.notificacoes .perfil-items .perfil-item {
        padding: 0;
        .perfil-label {
            width: 30%;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// Notificacoes.vue?4f53c579